'use client'

import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'

export const ThemeToggle = () => {
  const { setTheme, theme } = useTheme()
  const { t } = useTranslation()

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark')
  }

  return (
    <Button aria-label={t('global.toggleTheme')} onClick={toggleTheme} variant="outline">
      <div className="relative origin-center size-fit">
        <Moon className="h-4 w-4 rotate-0 origin-center scale-100 transition-all dark:-rotate-90 dark:scale-0" />
        <Sun className="absolute top-0 left-0 h-4 w-4 origin-center rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      </div>
      {t(
        theme === 'dark'
          ? 'settingsPage.changeTheme.fromDarkToLight'
          : 'settingsPage.changeTheme.fromLightToDark',
      )}
    </Button>
  )
}
